import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: 'Marcus Johnson',
    role: 'Business Owner',
    content: 'OmniBeast transformed our warehouse. The welding work was impeccable and done ahead of schedule.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Sarah Chen',
    role: 'Homeowner',
    content: 'Their cleaning team left my house spotless. Professional, thorough, and incredibly detail-oriented.',
    rating: 5,
  },
  {
    id: 3,
    name: 'David Rodriguez',
    role: 'Fleet Manager',
    content: 'Best mechanics in the city. They keep our entire fleet running smoothly with minimal downtime.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Emily Watson',
    role: 'Property Manager',
    content: 'The handyman services are outstanding. Quick response, fair pricing, and quality work every time.',
    rating: 5,
  },
  {
    id: 5,
    name: 'James Mitchell',
    role: 'Construction Foreman',
    content: 'Top-notch welding crew. They handled our custom fabrication project with expertise and precision.',
    rating: 5,
  },
  {
    id: 6,
    name: 'Lisa Park',
    role: 'Restaurant Owner',
    content: 'The deep cleaning service exceeded expectations. Our kitchen has never been this clean!',
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section className="py-24 overflow-hidden" data-testid="testimonials-section">
      <div className="px-6 md:px-12 lg:px-24 mb-12">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-[#00F0FF] font-medium tracking-wider uppercase text-sm">
              Testimonials
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mt-4">
              What Our <span className="gradient-text">Clients Say</span>
            </h2>
          </motion.div>
        </div>
      </div>

      {/* Marquee Container */}
      <div className="marquee-container py-4">
        <div className="marquee-content">
          {[...testimonials, ...testimonials].map((testimonial, index) => (
            <div
              key={`${testimonial.id}-${index}`}
              className="glass rounded-xl p-6 min-w-[350px] max-w-[350px] shrink-0"
              data-testid={`testimonial-card-${testimonial.id}`}
            >
              <Quote className="w-8 h-8 text-[#00F0FF]/30 mb-4" />
              <p className="text-gray-300 mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-white">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                </div>
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#00F0FF] text-[#00F0FF]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
